"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_redux_1 = require("react-redux");
var workflow_1 = require("../../../../../../../../reducers/slices/workflow/workflow");
var node_1 = __importDefault(require("../../node"));
var pro_light_svg_icons_1 = require("@fortawesome/pro-light-svg-icons");
var PackParcelNode = function (props) {
    var data = props.data;
    var dispatch = (0, react_redux_1.useDispatch)();
    var setNodeData = function (data) {
        dispatch((0, workflow_1.setNode)(__assign(__assign({}, props), { data: data })));
    };
    return ((0, jsx_runtime_1.jsx)(node_1.default, __assign({ category: "action", icon: pro_light_svg_icons_1.faTimer, data: data }, props)));
};
exports.default = (0, react_1.memo)(PackParcelNode);
